export class TabBasedNavigation {
	sanitizeFragmentId( value ) {
		// Keep it simple: allow common HTML id chars only.
		return String( value || '' ).replace( /[^A-Za-z0-9_-]/g, '' );
	}

	constructor( node ) {
		this.node = node;
		this.links = Array.from( node.querySelectorAll( '.tab-based-navigation__link[data-target-id]' ) );
		this.items = this.links
			.map( ( link ) => {
				const id = link.dataset.targetId;
				const target = id ? document.getElementById( id ) : null;
				return { id, link, target };
			} )
			.filter( ( item ) => item.id && item.target );

		if ( ! this.items.length ) {
			return;
		}

		this.onClick = this.onClick.bind( this );
		this.setActive = this.setActive.bind( this );
		this.updateActiveFromScroll = this.updateActiveFromScroll.bind( this );

		this.items.forEach( ( item ) => item.link.addEventListener( 'click', this.onClick ) );

		window.addEventListener( 'scroll', this.updateActiveFromScroll, { passive: true } );
		window.addEventListener( 'resize', this.updateActiveFromScroll );
		this.updateActiveFromScroll();
	}

	onClick( event ) {
		const link = event.currentTarget;
		const id = link.dataset.targetId;
		const target = id ? document.getElementById( id ) : null;

		if ( ! target ) {
			return;
		}

		event.preventDefault();
		target.scrollIntoView( { behavior: 'smooth', block: 'start' } );
		this.setActive( id );
		if ( window.history?.replaceState ) {
			window.history.replaceState( null, '', `#${ this.sanitizeFragmentId( id ) }` );
		}
	}

	updateActiveFromScroll() {
		const absTarget = window.scrollY + window.innerHeight / 3;

		let closestId = null;
		let closestDistance = Infinity;

		for ( const item of this.items ) {
			const rect = item.target.getBoundingClientRect();
			const absTop = window.scrollY + rect.top;
			const dist = Math.abs( absTop - absTarget );
			if ( dist < closestDistance ) {
				closestDistance = dist;
				closestId = item.id;
			}
		}

		if ( closestId ) {
			this.setActive( closestId );
		}
	}

	setActive( activeId ) {
		this.items.forEach( ( item ) => {
			const isActive = item.id === activeId;
			item.link.classList.toggle( 'is-active', isActive );
			item.link.setAttribute( 'aria-current', isActive ? 'true' : 'false' );
		} );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.tab-based-navigation' ).forEach( ( node ) => {
		new TabBasedNavigation( node );
	} );

	const header = document.querySelector( '.masthead' );
	const nav = document.querySelector( '.tab-based-navigation' );
	if ( ! header || ! nav ) {
		return;
	}

	document.addEventListener(
		'scroll',
		() => {
			if ( header.classList.contains( 'masthead--pinned' ) ) {
				const headerHeight = header.offsetHeight || 0;
				nav.style.setProperty(
					'--wdg-tab-based-navigation-top',
					`calc( ${ headerHeight }px - var(--wdg-masthead-utility-height) )`
				);
			} else {
				nav.style.setProperty( '--wdg-tab-based-navigation-top', '0px' );
			}
		},
		{ passive: true }
	);
} );

